module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo4_390x390.73cce37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo4_390x390.jpg
// module id = 332
// module chunks = 2